import { render, staticRenderFns } from "./NewProjectDetail.vue?vue&type=template&id=6dc0d6e4&scoped=true"
import script from "./NewProjectDetail.vue?vue&type=script&lang=js"
export * from "./NewProjectDetail.vue?vue&type=script&lang=js"
import style0 from "./NewProjectDetail.vue?vue&type=style&index=0&id=6dc0d6e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc0d6e4",
  null
  
)

export default component.exports